import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert as MuiAlert, Slide } from '@mui/material';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

const severityStyles = {
    error: {
        bgcolor: '#FEF2F2',
        borderColor: '#FECACA',
        color: '#991B1B',
        iconColor: '#EF4444',
    },
    warning: {
        bgcolor: '#FFFBEB',
        borderColor: '#FDE68A',
        color: '#92400E',
        iconColor: '#F59E0B',
    },
    success: {
        bgcolor: '#F0FDF4',
        borderColor: '#BBF7D0',
        color: '#166534',
        iconColor: '#10B981',
    },
    info: {
        bgcolor: '#FFFFFF',
        borderColor: '#E2E8F0',
        color: '#0F172A',
        iconColor: '#2563EB',
    },
};

function SlideUp(props) {
    return <Slide {...props} direction="up" />;
}

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({
        open: false,
        message: '',
        severity: 'info',
        duration: 4000,
    });

    const showToast = useCallback((message, severity = 'info', duration = 4000) => {
        setToast({ open: true, message, severity, duration });
    }, []);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setToast((prev) => ({ ...prev, open: false }));
    };

    const styles = severityStyles[toast.severity] || severityStyles.info;

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Snackbar
                open={toast.open}
                autoHideDuration={toast.duration}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                TransitionComponent={SlideUp}
                sx={{ mb: 2 }}
            >
                <MuiAlert
                    onClose={handleClose}
                    severity={toast.severity}
                    variant="outlined"
                    sx={{
                        width: '100%',
                        minWidth: { xs: 'auto', sm: 340 },
                        maxWidth: 'calc(100vw - 32px)',
                        bgcolor: styles.bgcolor,
                        borderColor: styles.borderColor,
                        color: styles.color,
                        borderRadius: 2,
                        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                        fontWeight: 500,
                        '& .MuiAlert-icon': {
                            color: styles.iconColor,
                        },
                    }}
                >
                    {toast.message}
                </MuiAlert>
            </Snackbar>
        </ToastContext.Provider>
    );
};
